import {createApp} from 'vue';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import ContactForm from '../components/contact-form.vue';

const app = createApp({
    components: {
        'contact-form': ContactForm,
    },
    props: {
    },
    data() {
        return {};
    },
}, window.propsData);

configureGlobalComponents(app);
app.mount('#trade-enquire-form');
